import { render, staticRenderFns } from "./ProductsModal.vue?vue&type=template&id=55bc408c&"
import script from "./ProductsModal.vue?vue&type=script&lang=js&"
export * from "./ProductsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports